/*
 * Copyright (c) 2022. American Express Company
 */

import React, { Component, ReactComponentElement } from 'react';

// import components
import Callout from './Callout';

// models and services
import { CalloutViewModel } from 'src/types/view-models/callout.view.model';

// stylesheets and icons
import { IconInfo } from '@americanexpress/dls-react';

export default class InfoCallout extends Component<CalloutViewModel> {
    public override render(): ReactComponentElement<any> {
        return (
            <Callout
                className={this.props.className}
                text={this.props.text}
                icon={<IconInfo className="info-icon" key="info-icon" />}
                defaultWidth={this.props.defaultWidth}
                type="info"
                noMargin={this.props.noMargin}
            >
                {this.props.children}
            </Callout>
        );
    }
}
